import { RevealOnScroll } from "./RevealOnScroll";

export type Capability = { name: string; detail: string };

export function Capabilities({ items }: { items: Capability[] }) {
  return (
    <RevealOnScroll>
      <div className="grid gap-px overflow-hidden rounded-lg border border-rule bg-rule sm:grid-cols-2">
        {items.map((c) => (
          <div key={c.name} className="flex items-baseline gap-4 bg-white px-5 py-4">
            <span className="text-cyan" aria-hidden>●</span>
            <div className="flex-1">
              <div className="font-medium text-ink">{c.name}</div>
              <div className="font-mono text-[11px] uppercase tracking-wider text-ink-4">
                {c.detail}
              </div>
            </div>
          </div>
        ))}
      </div>
    </RevealOnScroll>
  );
}
